import React from 'react';
import { Box, Divider, Paper, Stack, Typography } from '@mui/material';

export default function PaymentTotalsBar({
  invoiceCount = 0,
  totalInvoicesLabel = 'Q 0.00',
  adjustmentsLabel = 'Q 0.00',
  creditsLabel = 'Q 0.00',
  billCreditsLabel = 'Q 0.00',
  effectiveDueLabel = 'Q 0.00',
  paymentsLabel = 'Q 0.00',
  remainingLabel = 'Q 0.00',
  remainingIsCredit = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.25,
        border: '1px solid #eee',
        borderRadius: 2,
        background: '#fafbfc',
        maxWidth: '90%',
        mx: 'auto',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.25}
        alignItems={{ xs: 'stretch', sm: 'center' }}
      >
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Facturas
          </Typography>
          <Typography variant="subtitle2">{invoiceCount}</Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Total inicial
          </Typography>
          <Typography variant="subtitle2">{totalInvoicesLabel}</Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Ajustes
          </Typography>
          <Typography variant="subtitle2" color="success.main">
            -{adjustmentsLabel}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            NC / Abonos
          </Typography>
          <Typography variant="subtitle2" color="warning.main">
            -{creditsLabel}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Saldos a favor
          </Typography>
          <Typography variant="subtitle2" color="warning.main">
            -{billCreditsLabel}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box
          sx={{
            flex: 1,
            p: 0.25,
            borderLeft: (theme) => `4px solid ${theme.palette.primary.light}`,
            bgcolor: (theme) =>
              theme.palette.mode === 'dark'
                ? 'rgba(25,118,210,0.08)'
                : 'rgba(25,118,210,0.06)',
            borderRadius: 1,
          }}
        >
          <Typography variant="overline" color="text.secondary" sx={{ ml: 0.5 }}>
            Total a pagar
          </Typography>
          <Typography variant="subtitle2" sx={{ ml: 0.5 }}>
            {effectiveDueLabel}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Pagos
          </Typography>
          <Typography variant="subtitle2" color="success.main">
            -{paymentsLabel}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', sm: 'block' } }} />
        <Box sx={{ flex: 1, p: 0.25 }}>
          <Typography variant="overline" color="text.secondary">
            Saldo
          </Typography>
          <Typography variant="subtitle2" color={remainingIsCredit ? 'success.main' : 'primary.main'}>
            {remainingLabel}
          </Typography>
          {remainingIsCredit && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              A favor
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}
